import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from 'src/app/core/models/company';

@Component({
  selector: 'app-feature-icon',
  templateUrl: './feature-icon.component.html',
  styleUrls: ['./feature-icon.component.scss']
})
export class FeatureIconComponent {
  @Input() url!: string;
  @Input() title!: string;
  @Input() iconClass!: string

  constructor(
    private router: Router,
  ) {

  }

  getBackgroundColor() {
    return this.adjustColor(this.getColor(), 0.2);
  }


  getColor() {
    const currentCompany = new Company(JSON.parse(localStorage.getItem('current_company')!));
    return currentCompany.primary_color;
  }

  adjustColor(color: string, opacity: number) {
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);
    let alpha = Math.round(opacity * 255);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  navigatorTo() {
    this.router.navigateByUrl(this.url)
  }
}
